import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

export const useModalManagement = (refetchPriceList: () => void) => {
  const [isPickPriceListModalOpen, setIsPickPriceListModalOpen] = useState<boolean>(false);
  
  const openModal = useCallback(() => {
    setIsPickPriceListModalOpen(true);
  }, []);
  
  const closeModal = useCallback(() => {
    setIsPickPriceListModalOpen(false);
  }, []);
  
  const handleSelectPriceList = useCallback((priceLists: any[]) => {
    closeModal();
    refetchPriceList();
  }, [closeModal, refetchPriceList]);
  
  return {
    isPickPriceListModalOpen,
    openModal,
    closeModal,
    handleSelectPriceList
  };
};
